import i18n from '../../language/index'
import { staticRule, chineseRule } from "@/base/valid";
import { getStaticStr } from "@/base/base";
export default {
  name: "message",
  props: {
    tagList: {
      type: Array,
      default: () => [],
    },
    articleInfor: {
      type: Object,
      default: null,
    },
    treeData: {
      type: Array,
    },
    articleWords: {
      type: String,
      default: i18n.t('widgets_basic_article_classification_edit_333'),
    },
    articleType: {
      type: Number,
      default: 1, //1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
    },
    total: {
      type: Number,
      default: 0,
    },
    proParams: {
      type: Object,
      default: function() {
        return {
          title: i18n.t('components_basic_addarticle_index_2009'),
          type: "add", // 类型： 新增（add）或编辑(edit)
          twebId: 0, // 网站ID
          pid: "0", // 分类类型pid
          id: "0", // 分类类型ID
          objectType: "news", //  新增或编辑对象的类型 pro 分类类型
          typevalue: 1,
        };
      },
    },
  },
  data() {
    var myDate = new Date();
    var nowData = Date.parse(myDate);
    var summary_size = 2000
    var introLength = (rule, value, callback) => {
      if (this.wordslength > 70000) {
        callback(i18n.t('components_basic_addarticle_message_2017'));
      } else callback();
    };
    const validateContent = (rule, value, callback) => {
      if (typeof value == "string" && value.length > 100000) {
        callback(new Error(i18n.t('components_basic_addarticle_message_2018')));
      } else {
        callback();
      }
    };
    return {
      isShow: false,
      popShow: false,
      tree_data: this.treeData,
      article_infor: this.articleInfor,
      limitnumber: 15,
      imageUrl: [],
      rules: {
        title: [{
            required: true,
            message: i18n.t('components_ai_command_tkd_1957') + this.articleWords + i18n.t('widgets_basic_development_history_edit_498'),
            trigger: "blur",
          },
          {
            min: 2,
            max: 200,
            message: i18n.t('components_basic_addarticle_message_2019'),
            trigger: "blur"
          },
          { pattern: /\S+/, message: i18n.t('components_basic_addarticle_message_2020') },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        type_name: [{
          required: true,
          message: i18n.t('view_dialog_index_116') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348'),
          trigger: "change",
        }, ],
        sort: [{
          type: "number",
          max: 99999,
          min: 0,
          message: i18n.t('components_basic_addarticle_message_2021'),
          trigger: "blur"
        }, ],
        summary: [{
            required: true,
            message: i18n.t('components_ai_command_tkd_1957') + this.articleWords + i18n.t('widgets_basic_article_list_edit_404'),
            trigger: "blur",
          },
          {
            min: 20,
            max: summary_size,
            message: i18n.t('components_basic_addarticle_message_2022', [summary_size]),
            trigger: "blur"
          },
          {
            validator: chineseRule,
            trigger: "blur"
          }
        ],
        click: [{
          type: "number",
          max: 99999,
          min: 0,
          message: i18n.t('components_basic_addarticle_message_2023'),
          trigger: "blur",
        }, ],
        author: [{
          min: 2,
          max: 30,
          message: i18n.t('components_basic_addarticle_message_2024'),
          trigger: "blur"
        }, {
          validator: chineseRule,
          trigger: "blur"
        }],
        static: [{
            max: 80,
            message: i18n.t('components_basic_addarticle_message_2025')
          },
          {
            validator: staticRule,
            trigger: "blur"
          }
        ],
        source:[
        {
          validator: chineseRule,
          trigger: "blur"
        }],
      },
      ruleForm: {
        goods_id: "",
        title: "",
        pageviews: 0,
        album_ids: "", // 多个图片的ID
        type_name: "",
        type_id: "", //产品分类
        is_up: "true", //是否发布
        is_nostore: "true", //无库存销售
        bn: "", // 产品编码
        sort: 0, //产品排序
        img: "", //产品主图
        up_time: nowData,
        author: "",
        imageUrl: [],
        summary: "", // 产品简介
        brand: "", //品牌
        standard: "", //规格
        model: "", //型号
        unit: "", //单位
        minimum: "", //起订量
        pack: "", //包装说明
        content: '', // 本地上传 请输入视频链接
        static: '',
        source: '', // 来源
        click: 0,
      },
      fifterTree: false,
      defaultProps: {
        children: "children",
        label: "name",
      },
      autoSeo: {
        title: "",
        keywords: "",
        description: "",
      },
      imageUrl: []
    };
  },
  methods: {
    staticBlur() {
      this.article_infor.static = getStaticStr(this.article_infor.static);
    },
    getNewType() {
      this.$emit("getTypes");
    },
    setSeoSummary(data) {
      this.autoSeo.description = data;
      if (this.autotype == 1) {
        this.article_infor.seo_description = this.autoSeo.description;
      }
    },
    setSeoTitle(data) {
      this.autoSeo.title = data;
      this.autoSeo.keywords = data;
      if (this.autotype == 1) {
        this.article_infor.seo_keywords = this.autoSeo.keywords;
        this.article_infor.seo_title = this.autoSeo.title;
      }
    },
    showpop() {
      const that = this;
      let limit = 0
      if (this.articleType !== 11) {
        limit = 15 - that.article_infor.imageUrl.length;
      } else { // 视频主图 只有一个
        limit = 1 - that.article_infor.imageUrl.length;
      }

      this.$store.commit("image_upload/set_fileType", 1); //文件类型
      this.$store.commit("image_upload/set_showTag", true); //弹窗显示状态
      if (this.articleType == 11) {
        this.$store.commit("image_upload/set_fileLimit", 1); //文件数量限制
      } else {
        this.$store.commit("image_upload/set_fileLimit", limit); //文件数量限制
      }
      this.$store.commit("image_upload/set_limitMessage", i18n.t('components_basic_addarticle_message_2026')); //到达限制张数后的提示
      this.$store.state.image_upload.imgFile = (e) => {
        let pathList = e.map((e) => {
          e.img_path = e.filePath;
          return e;
        });
        // that.article_infor.imageUrl = that.article_infor.imageUrl.concat(pathList)
        if (this.articleType == 11) {
          that.article_infor.imageUrl = pathList;
        } else {
          that.article_infor.imageUrl = that.templet.filterArray(
            that.article_infor.imageUrl,
            pathList,
            "filePath"
          );
        }

        that.$store.state.image_upload.imgFile = null;
      };
    },
    showpop_video() {
      const that = this;
      this.$store.commit("image_upload/set_fileType", this.$store.state.image_upload.TYPE_VIDEO); //文件类型
      this.$store.commit("image_upload/set_showTag", true); //弹窗显示状态
      this.$store.commit("image_upload/set_fileLimit", 1); //文件数量限制
      this.$store.state.image_upload.imgFile = (e) => {
        let pathList = e.map((e) => {
          e.img_path = e.filePath;
          return e;
        });
        if (pathList[0].fileSize / 1024 / 1024 > 50) {
          that.$message.warning(i18n.t('components_basic_addarticle_message_2027'));
          return false;
        }
        that.article_infor.file.name = pathList[0].fileName;
        that.article_infor.content = pathList[0].filePath;
        that.article_infor.filename = pathList[0].fileName;
        // that.article_infor.imageUrl = that.article_infor.imageUrl.concat(pathList)
        that.article_infor.video.imageUrl = that.templet.filterArray(
          that.imageUrl,
          pathList,
          "filePath"
        );
        that.$store.state.image_upload.imgFile = null;
      };
    },
    showTree() {
      this.fifterTree = true;
      this.$refs.tree2.filter("false");
    },
    cleanFifter() {
      //this.is_clean = true
    },
    hiddenTree() {
      this.fifterTree = false;
    },
    choseOrg(val) {
      this.article_infor.type_name = val.name;
      this.article_infor.type_id = val.id;
      this.article_infor.category_id = val.id;
      this.article_infor.category_name = val.name;
      this.fifterTree = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      // return data.hide.indexOf(value) !== -1
      return true;
    },
    changemainpic(index) {
      let imglist = this.article_infor.imageUrl;
      let newlist = [];
      newlist.push(this.article_infor.imageUrl[index]);
      imglist.splice(index, 1);
      this.article_infor.imageUrl = newlist.concat(imglist);
    },
    closeavatar(index) {
      let data = this.article_infor.imageUrl;
      data.splice(index, 1);
    },
    resetFields() {
      this.$refs.article_infor.resetFields();
    },
    video_closeavatar() {
      this.article_infor.video.imageUrl = [];
    },
    openAddClass(isAddOrEdit, pid, id) {
      const info = isAddOrEdit === 'edit' ? i18n.t('components_basic_addarticle_index_2003') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348') : i18n.t('components_add_button_index_1953') + this.articleWords + i18n.t('widgets_basic_article_info_edit_348');
      this.proParams.typevalue = this.articleType;
      this.proParams.title = info;
      this.proParams.pid = pid;
      this.proParams.type = isAddOrEdit;
      this.proParams.id = id;
      this.isShow = true;
      if (this.proParams.objectType === 'product') {
        this.typeValue = 1;
      } else {
        this.typeValue = 2;
      }
    },
  },
  computed: {
    uploadtype() {
      if (
        this.article_infor.content &&
        this.article_infor.file &&
        this.article_infor.file.name != null
      ) {
        return 1;
      } else {
        return 2;
      }
    },
  },
  watch: {
    article_infor(val) {
      this.$emit("update:articleInfor", val); //双向数据绑定
    },
    articleInfor(val) {
      this.article_infor = this.articleInfor;
    },
  },
  mounted() {
  },
};


// WEBPACK FOOTER //
// ./src/components/basic_addArticle/message.js